import {createContext, useEffect, useMemo, useState} from "react";
import {BrowserRouter, Routes, Route} from "react-router-dom";
import Container from "react-bootstrap/Container";
import Header from "./layout/components/Header";
import Sidebar from "./layout/components/Sidebar";
import Login from "./layout/pages/login/Login";
import "./layout/styles/common/reset.scss";
import DashPlatform from "./layout/pages/dasbboard/DashPlatform";
import DashBrokerServer from "./layout/pages/dasbboard/DashBrokerServer";
import DashFireStatus from "./layout/pages/dasbboard/DashFireStatus";
import ConfMobileFacilitiesWeak from "./layout/pages/configuration/ConfMobileFacilitiesWeak";
import ConfGateway from "./layout/pages/configuration/ConfGateway";
import ConfRepeater from "./layout/pages/configuration/ConfRepeater";
import ConfSensorEquipment from "./layout/pages/configuration/ConfSensorEquipment";
import ConfControlHistory from "./layout/pages/configuration/ConfControlHistory";
import {RecoilRoot} from "recoil";
import FaultStatus from "./layout/pages/fault/FaultStatus";
import FaultHistory from "./layout/pages/fault/FaultHistory";
import PerfGateway from "./layout/pages/performance/PerfGateway";
import PerfRepeater from "./layout/pages/performance/PerfRepeater";
import PerfSensorEquipment from "./layout/pages/performance/PerfSensorEquipment";
import PerfSystem from "./layout/pages/performance/PerfSystem";
import PerfBrokerServer from "./layout/pages/performance/PerfBrokerServer";
import TrafAbnormalTraffic from "./layout/pages/traffic/TrafAbnormalTraffic";
import TrafTransmitReceiveHistory from "./layout/pages/traffic/TrafTransmitReceiveHistory";
import UserAuthentication from "./layout/pages/user/UserAuthentication";
import UserAccreditation from "./layout/pages/user/UserAccreditation";
import UserTopic from "./layout/pages/user/UserTopic";
import UserAccessAuthorityHistory from "./layout/pages/user/UserAccessAuthorityHistory";
import SysSmsShipmentSettings from "./layout/pages/system/SysSmsShipmentSettings";
import SysFirmware from "./layout/pages/system/SysFirmware";
import SysSmsShipmentHistory from "./layout/pages/system/SysSmsShipmentHistory";
import SysReportHistory119 from "./layout/pages/system/SysReportHistory119";
import SysFcltyDept from "./layout/pages/system/SysFcltyDept";
import SysReport from "./layout/pages/system/SysReport";
import HeaderNew from "./layout/components/HeaderNew";
import HeaderNN from "./layout/components/HeaderNN";
import ResetPW from "./layout/pages/login/ResetPW";
import { library } from '@fortawesome/fontawesome-svg-core';
import { faHouse, } from '@fortawesome/free-solid-svg-icons';
import { faWheelchair, faTowerBroadcast, faTowerCell, faTemperatureArrowUp, faClockRotateLeft } from '@fortawesome/free-solid-svg-icons';
import { faList } from '@fortawesome/free-solid-svg-icons';
import { faDesktop, faServer } from '@fortawesome/free-solid-svg-icons';
import { faTriangleExclamation } from '@fortawesome/free-solid-svg-icons';
import { faUserShield, faUsersGear, faRightLeft } from '@fortawesome/free-solid-svg-icons';
import { faCommentSms, faFloppyDisk, faTruckMedical, faFile } from '@fortawesome/free-solid-svg-icons';

import SysReportReg from "./layout/pages/system/SysReportReg";
import Swal from "sweetalert2";
import {getRealtimeFire} from "./api/apiClient";
import PageTest1 from "./layout/pages/PageTest1";
import PageTest2 from "./layout/pages/PageTest2";
import Dash from "./layout/pages/dasbboard/Dash";


library.add(faHouse);
library.add(faWheelchair, faTowerBroadcast, faTowerCell, faTemperatureArrowUp, faClockRotateLeft);
library.add(faList);
library.add(faDesktop, faServer);
library.add(faTriangleExclamation);
library.add(faUserShield, faUsersGear, faRightLeft);
library.add(faCommentSms, faFloppyDisk, faTruckMedical, faFile);



/* location을 전역으로 관리하기 위한 context 선언 */
export const locationContext = createContext({
  setLocation: () => {
  }
});
// 전역 상태 관리에 대해서 다시 생각해볼 필요가 있음.

const App = () => {

  /* 현재 페이지를 저장하고 비교할 state 관리 선언 */
  const [location, setLocation] = useState('');
  /* 페이지에 해당하는 헤더와 사이드바 메뉴 state 관리 선언 */
  const [activeMenu, setActiveMenu] = useState('');
  /* memoization을 사용하여 수행한 연산의 결괏값을 저장해두고 동일한 입력이 들어오면 재활용 */
  const value = useMemo(() => ({setLocation, setActiveMenu}), [setLocation, setActiveMenu]);

  useEffect(() => {
    if (location.includes('dash')) {
      setActiveMenu('dashboard');
    } else if (location.includes('conf')) {
      setActiveMenu('configuration');
    } else if (location.includes('fault')) {
      setActiveMenu('fault');
    } else if (location.includes('perf')) {
      setActiveMenu('performance');
    } else if (location.includes('traffic')) {
      setActiveMenu('traffic');
    } else if (location.includes('user')) {
      setActiveMenu('user');
    } else if (location.includes('sys')) {
      setActiveMenu('system');
    } else if (location.includes('broker')) {
      setActiveMenu('grafana');
    }
  }, [location]);

  const prefix = 'ui';



  const [stCheck, setCheck] = useState(0);
  useEffect(() => {
    let fireInterval;
    console.log('start checking')
    fireInterval = setInterval(updateFire, 10000);
    setCheck(fireInterval);
    console.log(fireInterval)

  }, [])

  const stopChecking = () => {
    console.log('stop')
    console.log(stCheck);
    clearInterval(stCheck);
    setCheck(0);
  }

  const [stFireStatus, setFireStatus] = useState([])


  const updateFire = () => {
    if (sessionStorage.getItem('ACCESS_TOKEN') != null) {
      getRealtimeFire().then((resp) => {
        console.log(resp);
        if (resp.data.data != undefined) {
          setFireStatus(resp.data.data.list);
        }
      });
    } else {
      console.log('has no access token. ignore alert. (logout).')
    }
    // console.log(sessionStorage.getItem('ACCESS_TOKEN'))
  }

// atdrc_nm:"서초구"
// fclty_nm:"STI(시뮬레이터용)"
// fclty_no:10001
// fire_no:7
// ocrn_dt_str:"2022-12-14 21:17:00"

  useEffect(() => {
    showFireAlarm();
  }, [stFireStatus])

  // 시나리오 요약.
  // 팝업은 중복이 불가하여 동시 화재 발생 시 하나에 표기함.
  // 그러나 액션은 1개이며, 동시에 여러 화재를 off 하는 것은 권장하지 않으므로
  // 여러개를 표기하더라도 그만 보기는 첫번째 화재에 대해서 세션 스토리지에 저장.

  const offFireAlarm = (fire_no) => {
    console.log(`[FIRE ALARM] Turn off. fire_no = ${fire_no}`);
    sessionStorage.setItem(`fire_no[${fire_no}]`, 'OFF');
  }

  const isOnFireAlarm = (fire_no) => {
    console.log(`[FIRE ALARM] Check fire alarm. fire_no = ${fire_no}`);
    if(sessionStorage.getItem(`fire_no[${fire_no}]`) == undefined) {
      return true;
    } else {
      return false;
    }
  }

  const showFireAlarm = () => {
    // let isFire = stFireStatus.length > 0
    let isFire = false
    let firstFireNo = 0;
    let html_text = ''

    for (let i = 0 ; i < stFireStatus.length ; i++) {
      if (isOnFireAlarm(stFireStatus[i].fire_no)) {
        html_text += (`${stFireStatus[i].atdrc_nm} ${stFireStatus[i].fclty_nm} ` +
                      `일시: ${stFireStatus[i].ocrn_dt_str} <br/>`);
        isFire = true;
        if (firstFireNo == 0) {
          firstFireNo = stFireStatus[i].fire_no;
        }
      }
    }

    if (isFire) {
      Swal.fire({
        title: '화재 발생',
        icon: 'warning',
        html: html_text,
        width: 800,
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: '그만 보기',
        denyButtonText: `확인`,
      }).then((result) => {
        /* Read more about isConfirmed, isDenied below */
        if (result.isConfirmed) {
          //stopChecking();
          offFireAlarm(firstFireNo);
        } else if (result.isDenied) {

        }
      })
    }
    console.log('check fire!!!!');
  }


  return (
      <locationContext.Provider value={value}>
        <RecoilRoot>
          <BrowserRouter>
            <Container fluid className={'p-0 wrapper'}>
              {/*<Header activeMenu={activeMenu}/>*/}
              {/*<HeaderNew />*/}
              <HeaderNN activeMenu={activeMenu}/>
              <div className={'main'}>
                <Sidebar activeMenu={activeMenu}/>
                <Routes>
                  <Route path={`/`} element={<Login/>}/>
                  <Route path={`/${prefix}/login`} element={<Login/>}/>
                  <Route path={`/${prefix}/reset-pw`} element={<ResetPW/>}/>

                  {/* 대시보드 */}
                  <Route path={`/${prefix}/dash_platform`} element={<DashPlatform/>}/> {/* 대시보드 */}
                  <Route path={`/${prefix}/broker-server`} element={<DashBrokerServer/>}/>
                  <Route path={`/${prefix}/dash_fire-status`} element={<DashFireStatus/>}/> {/* 화재 현황 */}
                  <Route path={`/${prefix}/dash`} element={<Dash/>}/> {/* 화재 현황 */}

                  {/* 구성 관리 */}
                  <Route path={`/${prefix}/conf_mobile-facilities-weak`} element={<ConfMobileFacilitiesWeak/>}/>  {/* 이동약자시설 */}
                  <Route path={`/${prefix}/conf_gateway`} element={<ConfGateway/>}/>  {/* 게이트웨이 */}
                  <Route path={`/${prefix}/conf_repeater`} element={<ConfRepeater/>}/>  {/* 중계기 */}
                  <Route path={`/${prefix}/conf_sensor-equipment`} element={<ConfSensorEquipment/>}/> {/* 센서 장비 */}
                  <Route path={`/${prefix}/conf_control-history`} element={<ConfControlHistory/>}/> {/* 제어 이력 */}
                  
                  {/* 장애관리 */}
                  <Route path={`/${prefix}/fault-status`} element={<FaultStatus />}/>  {/* 장애 현황 */}
                  <Route path={`/${prefix}/fault-history`} element={<FaultHistory />}/>  {/* 장애 이력 */}

                  {/* 성능 관리 */}
                  <Route path={`/${prefix}/perf_gateway`} element={<PerfGateway />}/>  {/* 게이트웨이 */}
                  <Route path={`/${prefix}/perf_repeater`} element={<PerfRepeater />}/>  {/* 중계기 */}
                  <Route path={`/${prefix}/perf_sensor-equipment`} element={<PerfSensorEquipment />}/>  {/* 센서 장비 */}
                  <Route path={`/${prefix}/perf_system`} element={<PerfSystem />}/>  {/* 시스템 */}
                  <Route path={`/${prefix}/perf_broker-server`} element={<PerfBrokerServer />}/>  {/* 브로커서버 */}

                  {/* 트래픽 관리 */}
                  <Route path={`/${prefix}/traf_abnormal-traffic`} element={<TrafAbnormalTraffic />}/>  {/* 이상 트래픽 */}
                  <Route path={`/${prefix}/traf_transmit-receive-history`} element={<TrafTransmitReceiveHistory />}/>  {/* 송수신 이력 */}

                  {/* 사용자 관리 */}
                  <Route path={`/${prefix}/user_authentication`} element={<UserAuthentication/>}/>  {/* 인증 (계정관리) */}
                  <Route path={`/${prefix}/user_accreditation`} element={<UserAccreditation/>}/>  {/* 인가 관리 */}
                  <Route path={`/${prefix}/user_topic`} element={<UserTopic/>}/>  {/* 토픽 (MQTT 계정관리) */}
                  <Route path={`/${prefix}/user_access-authority-history`} element={<UserAccessAuthorityHistory/>}/>  {/* 접근 권한 이력 */}

                  {/* 시스템 관리 */}
                  <Route path={`/${prefix}/sys_sms-shipment-settings`} element={<SysSmsShipmentSettings/>}/>  {/* SMS 발송 설정 */}
                  <Route path={`/${prefix}/sys_firmware`} element={<SysFirmware/>}/>  {/* 펌웨어 */}
                  <Route path={`/${prefix}/sys_sms-shipment-history`} element={<SysSmsShipmentHistory/>}/>  {/* SMS 발송 이력 */}
                  <Route path={`/${prefix}/sys_report-history-119`} element={<SysReportHistory119/>}/>  {/* 119 신고 이력 */}
				  <Route path={`/${prefix}/sys_fclty-dept`} element={<SysFcltyDept/>}/>  {/* 화재안전관리자 */}
                  <Route path={`/${prefix}/sys_report`} element={<SysReport/>}/>  {/* 보고서 */}
                  <Route path={`/${prefix}/sys_report-reg`} element={<SysReportReg/>}/>  {/* 보고서 등록 */}

                  <Route path={`/${prefix}/test1`} element={<PageTest1/>}/>
                  <Route path={`/${prefix}/test2`} element={<PageTest2/>}/>

                </Routes>
              </div>
            </Container>
          </BrowserRouter>
        </RecoilRoot>

      </locationContext.Provider>
  );
}

export default App;
